<!-- start cta -->
<section class="py-5 bg-primary position-relative">
	<div class="bg-overlay bg-overlay-pattern opacity-50"></div>
	<div class="container">
		<div class="row align-items-center gy-4">
			<div class="col-sm">
				<div>
					<h4 class="text-white mb-0 fw-semibold">
						Build your web App/SaaS with Velzon dashboard
					</h4>
				</div>
			</div>
			<!-- end col -->
			<div class="col-sm-auto">
				<div>
					<a
						href="https://1.envato.market/velzon-admin"
						target="_blank"
						class="btn bg-gradient btn-danger"
						><i
							class="ri-shopping-cart-2-line align-middle me-1"
						></i>
						Buy Now</a
					>
				</div>
			</div>
			<!-- end col -->
		</div>
		<!-- end row -->
	</div>
	<!-- end container -->
</section>
<!-- end cta -->
